export default __webpack_public_path__ + "static/media/logocompleto.0de093ac.png";